import styled from 'styled-components';
import breakpoint from 'Styles/breakpoints';
import { fontBody } from 'Styles/fonts';

import ResponsiveImage from '../../../ResponsiveImage/ResponsiveImage';
import ButtonIcon from '../../../Icons/ButtonIcon';
import OverlayModal from '../../../ContentSystem/components/OverlayModal/OverlayModal';
import { FixedComponent as CloseButton } from '../../../DialogHeader/DialogHeader.styled';

export const ProductImageZoom = styled.div`
  overflow-x: scroll;

  ${breakpoint('medium')} {
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: repeat(12, 1fr);
    margin: 24px auto;
    padding: 24px 0;
    max-width: 1520px;
    position: relative;
    grid-gap: 24px;
  }
`;

export const Image = styled(ResponsiveImage)`
  touch-action: pan-x pan-y;
  height: 100vh;
  width: 100vh;

  ${breakpoint('medium')} {
    width: 100%;
    height: auto;
    grid-column: 3 / span 8;
    margin-left: 0;
    transform: none;
  }
`;

export const Button = styled(ButtonIcon)`
  ${fontBody(20)};
  position: fixed;
  bottom: 32px;
  margin-left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  height: 64px;
  width: 140px;
`;

export const Modal = styled(OverlayModal)`
  ${CloseButton} {
    top: 24px;

    ${breakpoint('medium')} {
      top: 32px;
    }
  }
`;
